import PropTypes from 'prop-types';
import React from 'react';
import EventDetails from '../../EventDetails/components/EventDetails';

import Popup from "reactjs-popup";

const popupContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "var(--sl-shadow-sm)",
  "width": "206px",
  "padding": "0px",
  "background": "var(--sl-bg-primary)"
}

const PageFrame = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  onConfirmChanged,
  showPageFrame,
  downloadLinks,
  titleAccessory,
  headerAside,
  children
}) => {
  const defaultLinks = [
    {
      href: `/teams/${team.id}/confirms/${confirm.id}/profit_and_loss.pdf`,
      icon: "far fa-file-pdf",
      label: "Download PDF"
    },
    {
      href: `/teams/${team.id}/confirms/${confirm.id}/profit_and_loss.csv`,
      icon: "far fa-file-csv",
      label: "Download CSV"
    }
  ];

  const links = downloadLinks || defaultLinks;

  return (
    showPageFrame ? (
      <div>
        <div className="row">
          <div className="col-12 col-md">
            <div className="page-title d-flex align-items-center"
                  style={{"marginBottom": "4px"}}>
              <span style={{"fontSize": "20px"}}>
                {confirm.name}
              </span>
              {confirm.calendar_classification === "offer" ? (
                <span className="badge badge-secondary mt-1 ml-3 p-2"
                      style={{"background": "#919191", "color": "var(--sl-text-white)", "fontSize": "10px"}}>
                  Draft
                </span>
              ) : confirm.calendar_classification === "past" ? (
                <span className="badge badge-secondary mt-1 ml-3 p-2"
                      style={{"background": "#919191", "color": "var(--sl-text-white)", "fontSize": "10px"}}>
                  Past
                </span>
              ) : confirm.calendar_classification === "canceled" ? (
                <span className="badge badge-danger mt-1 ml-3 p-2"
                      style={{"fontSize": "10px"}}>
                  Canceled
                </span>
              ) : confirm.calendar_classification === "postponed" ? (
                <span className="badge badge-warning mt-1 ml-3 p-2"
                      style={{"fontSize": "10px"}}>
                  Postponed
                </span>
              ) : confirm.calendar_classification === "on_sale" ? (
                <span className="badge badge-secondary mt-1 ml-3 p-2"
                      style={{"background": "#5f5383", "color": "var(--sl-text-white)", "fontSize": "10px"}}>
                  On Sale
                </span>
              ) : confirm.calendar_classification === "pre_sale" ? (
                <span className="badge badge-secondary mt-1 ml-3 p-2"
                      style={{"background": "#FF7A00", "color": "var(--sl-text-white)", "fontSize": "10px"}}>
                  Pre Sale
                </span>
              ) : confirm.calendar_classification === "announced" ? (
                <span className="badge badge-secondary mt-1 ml-3 p-2"
                      style={{"background": "#98c648", "color": "var(--sl-text-white)", "fontSize": "10px"}}>
                  Announced
                </span>
              ) : confirm.calendar_classification === "hold" ? (
                <span className="badge badge-secondary mt-1 ml-3 p-2"
                      style={{"background": "#f7ca58", "color": "black", "fontSize": "10px"}}>
                  Hold
                </span>
              ) : (
                <span className="badge badge-secondary mt-1 ml-3 p-2"
                      style={{"background": "#4c81b9", "color": "var(--sl-text-white)", "fontSize": "10px"}}>
                  Confirmed
                </span>
              )}
              {titleAccessory}
            </div>
            <EventDetails
              csrfToken={csrfToken}
              team={team}
              confirm={confirm}
              currentUser={currentUser}
              onConfirmSaved={onConfirmChanged}
            />
          </div>
          {headerAside}
          <div className="col-12 col-md-auto d-flex justify-content-end"
              style={{"paddingRight": "15px"}}>
            <Popup arrow={false}
                  offsetY={10}
                  position="bottom right"
                  contentStyle={popupContentStyle}
                  onOpen={
                    (e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }
                  }
                  trigger={open => (
                    <a className="btn btn-primary btn-sm align-self-end"
                      style={{"marginBottom": "16px", "borderRadius": "8px"}}
                      href="#">
                      Actions
                      <i aria-hidden className="fas fa-caret-down pl-2"></i>
                    </a>
                  )} >
            {close => (
              <div className='row text-left'>
                <div className="col-12">
                  <ul className="list-group offer-inline-menu">
                    {links.map((link, index) => (
                      <li key={index} className="list-group-item" style={{"padding": "10px 18px"}}>
                        <a
                          href={link.href}
                          target={link.target || "_blank"}
                          rel="noopener noreferrer"
                          className='text-dark'
                        >
                          <i className={`${link.icon} fa-fw text-muted`} style={{"marginRight": "15px"}}></i>
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            </Popup>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card no-border shadow-2">
              <div className="card-body" style={{"padding": "15px 15px 200px 15px"}}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div>{children}</div>
    )
  );
};

PageFrame.propTypes = {
  csrfToken: PropTypes.string,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object,
  confirm: PropTypes.object,
  onConfirmChanged: PropTypes.func,
  showPageFrame: PropTypes.bool,
  downloadLinks: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    target: PropTypes.string,
  })),
  titleAccessory: PropTypes.node,
  headerAside: PropTypes.node,
  children: PropTypes.element.isRequired
};

export default PageFrame;
